type Input = {
  value: number
  valueCurrencyCode: string
  defaultCurrencyCode: string
  fxRatesByCode: Record<string, number>
}

type AmountInput = Omit<Input, 'fxRatesByCode'> & {
  valueFxRate: number | undefined
  defaultFxRate: number | undefined
}

export const convertToDefaultCurrency = ({
  value,
  valueCurrencyCode,
  defaultCurrencyCode,
  fxRatesByCode,
}: Input): number | null =>
  convertAmountToDefaultCurrency({
    value,
    valueCurrencyCode,
    defaultCurrencyCode,
    valueFxRate: fxRatesByCode[valueCurrencyCode],
    defaultFxRate: fxRatesByCode[defaultCurrencyCode],
  })

export const convertAmountToDefaultCurrency = ({
  value,
  valueCurrencyCode,
  defaultCurrencyCode,
  valueFxRate,
  defaultFxRate,
}: AmountInput): number | null => {
  if (valueCurrencyCode === defaultCurrencyCode) return value
  if (valueFxRate == null || defaultFxRate == null) return null

  return Math.round(((value * defaultFxRate) / valueFxRate) * 100) / 100
}
